import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'TitleCase',
    standalone: false
})
export class TitleCasePipe implements PipeTransform {
  transform(value: string, args?: any): string {
    if (!value || value.length === 0) {
      return '';
    }
    return value[0].toUpperCase() + value.slice(1).toLowerCase();
  }
}
